/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 线索询价列表+get
// 接口地址 /api/v1/used_car/ticket/enquiries
Mock.mock(/used_car\/ticket\/enquiries$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'enquiries|10': [{
      'enquiry_id': 1,
      'ticket_id': 1, // # 对应的线索id
      'car_info_id': 1, // # 对应的评估快照id
      'car_image': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
      'finished_at': '2012-12-12 12:12',
      'maximum_quote_price': 12000000 // # 最高报价 为0表示没有
    }],
    'total_count': 55
  }
})

// 拍卖询价列表+get
// 接口地址 /api/v1/auctions/auction_car_enquiries
Mock.mock(/auctions\/auction_car_enquiries/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'enquiries|10': [{
      'auction_car_id': 25,
      'enquiry_id': 1,
      'ticket_id': 1, // # 对应的线索id
      'car_info_id': 1, // # 对应的评估快照id
      'car_image': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg',
      'car_model_name': '汉兰达/2015款2.0T两驱精英版 5座',
      'finished_at': '2012-12-12 12:12',
      'maximum_quote_price': 12000000 // # 最高报价 为0表示没有
    }],
    'total_count': 45
  }
})

// 车辆询价列表（注意与车辆询价模块区分，此接口返回的询价包括车辆询价和线索询价）
Mock.mock(/auction_cars\/\d+\/enquiries/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'enquiries|10': [{
      'auction_car_id': 2062, // 车辆id
      'ticket_id': 1000, // 线索id
      'car_image': 'https://some.path.com/to/image.jpg', // 车辆照片
      'car_model_name': '奥迪blahblah', // 车型
      'car_info_id': 4037, // 车辆快照id
      'enquiry_id': 752, // 询价id
      'finished_at': '2018-6-21-14:43:33', // 结束时间
      'is_finished': 'true', // 询价是否已结束
      'maximum_quote_price': 10000, // 最大报价，单位分
      'plate_number': '粤A12344', // 车牌
      'vin': 'ABCDEFGHIJKLMN1234', // 车架号
      'enquiry_type': 1 // 询价类型（1为线索，2为车辆）注意线索询价信息与车辆询价信息为两个接口，都用enquiry_id去请求
    }],
    'total_count': 45
  }
})
